// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"38":"b63e8f71","293":"749a6d3e"}[chunkId] + ".js";
};